import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import { useUser } from "../context/useInfo";
import amplitude from "../utils/amplitude";

Modal.setAppElement("#root");

const PaymentModal = ({ isOpen, onRequestClose  }) => {
  const [loading, setLoading] = useState(false);
  const {userData} = useUser();
  const [emailUser, setEmail] = useState(userData.email || "");
  const option = userData.selectedOption

useEffect(() => {
  if(process.env.NODE_ENV === "production"){
    fbq('track', 'Subscribe', {value: option.discount, currency: 'USD', predicted_ltv: '0.00'});

  }

  if (isOpen) {
    // Блокируем скролл на body и html
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    // Дополнительно фиксируем позицию
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  }

  return () => {
    // Восстанавливаем скролл при закрытии
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
  };
}, [isOpen]);

 

  const handleSubscribe = async () => {
    if (!emailUser) return alert("Введите email для подписки");
    setLoading(true);
    const data = {email: emailUser}

    if (userData && Object.keys(userData).length > 0) {
      localStorage.setItem(
        "userData",
        JSON.stringify({
          ...userData,
          email: emailUser, // или data, если оно у тебя есть в текущем scope
        })
      );
    }


    try {
    // 1. Запрос на бэкенд
    const response = await fetch("https://us-central1-ai-build-ship-stream-as-l1mzrg.cloudfunctions.net/createCheckoutSession", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ priceId: option.price_id, email: userData.email })
    });

    const data = await response.json();

    if (!data.sessionId) {
      throw new Error("Failed to create checkout session");
    }

    // 2. Получаем Stripe и делаем редирект через sessionId
    
        const stripeProduction = window.Stripe("pk_live_51QA7KrJM0DnG2MaAT5AlDSYQutafMAuXjZDv8XQysswJSypH0X2cIKm7yff2A6AhEdXHMjkFuHOlklYrTS3ZR2Zp00fMWhc20Y");
        // const stripeSandbox = window.Stripe("pk_test_51SBXaPJqJyyIEbrVJmJFowXuKTCeQ4Sxizo5wDaFDVD7aKAV6byBx8GVv2A7QoyLl1OHjb0uMaymdIpMVr2ezyXB00aO3Y428b");
    const { error } = await stripeProduction.redirectToCheckout({ sessionId: data.sessionId });

    if (error) {
      console.error(error);
      alert(error.message);
    }

  } catch (err) {
    console.error("Stripe Checkout error:", err);
    alert(err.message);
  } finally {
    setLoading(false);
  }


  };


  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 animate-fade-in z-50"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
    >
      <button
        onClick={onRequestClose}
        className="absolute top-4 right-4 text-gray-400 text-xl"
      >
        &times;
      </button>

      <h2 className="text-xl font-bold mb-6 text-center">
        Select a subscription
      </h2>

      <div className="text-sm mb-2">
        {option.title}
        <span className="float-right">{option.price}</span>
      </div>
      <div className="text-sm mb-2">
        -50% discount <span className="float-right">{option.discount}</span>
      </div>
      <div className="text-base font-semibold border-t border-b py-2 mb-4">
        Total <span className="float-right text-indigo-500">{option.total}</span>
      </div>

      <div className="bg-gray-50 rounded-lg p-3 text-xs text-gray-600 mb-4">
        <p className="mb-3">
          This is an autorenewing subscription. First payment:{" "}
          {option.priceWithDiscount}.
        </p>
        <p className="mb-3">
          All future payments: {option.price} {option.period} until cancellation.
        </p>
      </div>

      {/* Email input */}
      <div className="mb-4">
        <input
          type="email"
          value={emailUser}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          className="w-full border border-gray-300 rounded-lg p-3 text-sm"
          required
        />
      </div>

      {/* Subscribe Button */}
      <button
        onClick={handleSubscribe}
        disabled={loading}
        className="w-full bg-black text-white py-3 rounded-full font-semibold text-sm hover:bg-gray-900 transition"
      >
        {loading ? "Processing..." : "Subscribe"}
      </button>
    </Modal>
  );
};

export default PaymentModal;
